import { TimelineMax, Power3 } from 'gsap';

const EnterAge = (element) => {
  const logo = element.querySelector('.loader__logo');
  const age = element.querySelector('.loader__age');

  const tl = new TimelineMax({ paused: true, delay: 0.6 });
  tl.addLabel('start')
    .to(logo, 0.6, {
      y: -100,
      ease: Power3.easeInOut,
    }, 'start')
    .to(age, 0.6, {
      y: 0,
      autoAlpha: 1,
      ease: Power3.easeInOut,
    }, 'start+=0.1');
  return tl;
};

export default EnterAge;
